import React from "react";
import { GlobalContext } from '../utils/globalprovider';


class AppBase extends React.Component
{

    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        this.state = {}
    }  


    doExternalSave()
    {
        
    }

    canClose()
    {
        return false;

    }

    onCancelKeyboardEvent(valuer)
    {
        
    }

}

export default AppBase;
